import { Box, IconButton, Chip, Tooltip } from "@mui/material";
import { Abc, Check } from "@mui/icons-material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { swapElements } from "helpers/drag-and-drop";
import { P } from "theme/typography";
import { NewGreys } from "theme/palette";

interface EditModeProps {
  setEditMode: (editMode: boolean) => void;
  selectOptions: string[];
  setSelectOptions: (result: any) => void;
  showAlphebeticalSort?: boolean;
}
const EditMode = ({ setEditMode, selectOptions, setSelectOptions, showAlphebeticalSort }: EditModeProps) => {
  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }
    const items = swapElements(selectOptions, result.source.index, result.destination.index);
    setSelectOptions(items);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        marginBottom: "39px",
        mt: 0.5,
      }}>
      <Box
        sx={{
          display: "flex",
        }}>
        <Tooltip title="Save Order">
          <IconButton
            onClick={() => {
              setEditMode(false);
            }}>
            <Check />
          </IconButton>
        </Tooltip>
        {showAlphebeticalSort && (
          <Tooltip title="Sort Alphabetically">
            <IconButton
              onClick={() => {
                setSelectOptions(
                  selectOptions.slice().sort((a, b) => {
                    if (a.toLowerCase() === "other") {
                      return 1;
                    }
                    if (b.toLowerCase() === "other") {
                      return -1;
                    }
                    return a.localeCompare(b);
                  })
                );
              }}>
              <Abc />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <div
        style={{
          display: "flex",
          flex: 1,
          position: "relative",
          minWidth: 0,
          height: 40,
          padding: "8px 8px 0px 8px",
          border: `1px solid ${NewGreys.muiInputGrayBorder}`,
          borderRadius: 8,
        }}>
        <Box
          sx={{
            position: "absolute",
            top: -11,
            left: 8,
            backgroundColor: "white",
            paddingLeft: 0.5,
            paddingRight: 1,
          }}>
          <P
            variant="xs"
            style={{
              // mimic of the MUI input label styling
              color: "rgba(0, 0, 0, 0.6",
              fontSize: "10px",
              fontWeight: 600,
            }}>
            Drag and drop to reorder
          </P>
        </Box>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable" direction="horizontal">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{
                  display: "flex",
                  width: "100%",
                  overflowX: "auto",
                  // no scrollbar
                  scrollbarWidth: "none",
                }}>
                {selectOptions.map((item, index) => (
                  <Draggable key={item + index} draggableId={`${item} ${index}`} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                          marginRight: 4,
                        }}>
                        <Chip label={<P>{item}</P>} size="small" />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </Box>
  );
};

export default EditMode;
